import React, { Suspense } from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Topbar from "./Topbar";
import { Route, Routes } from "react-router-dom";
import routes from "../utils/routes";
import Home from "../../views/dashboard/Home";
import NotFound from "../../views/dashboard/NotFound";

function DefaultLayout() {

    return (
        <main className="main" id="top">
            <div className="container" data-layout="container">
                <Sidebar />
                <div className="content">
                    <Topbar />

                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes>
                            {routes.map((route, idx) =>
                                <Route key={idx} path={route.path} element={<route.component />} />)}
                            <Route path="/" element={<Home />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Suspense>

                    <Footer />
                </div>
            </div>
        </main>
    );
}

export default DefaultLayout;
